import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';

import { CollaborationRow } from './interfaces';

export const assistantsColumns: TableColumns<CollaborationRow> = [
  {
    title: 'lender.brokers.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 250,
  },
  {
    title: 'lender.brokers.labels.collaboration',
    key: 'collaborationType',
    width: 200,
  },
  {
    title: 'lender.brokers.labels.role',
    dataIndex: 'roles',
    key: 'roles',
    width: 250,
    options: {
      format: { type: 'multiValueList' },
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.email',
    dataIndex: 'email',
    key: 'email',
    width: 280,
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 80, fixed: 'right' },
];
